import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import DataGridV2 from '../../components/DataGridV2';
import { apps, LOCAL_STORAGE_GRID_KEYS } from '../../_constants';
import { getLocalStorageItem, setLocalStorageItem } from '../../_helpers';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { INITIAL_ROW_SELECTION_MODEL } from '../../components/DataGridV2/constants';
import { Delete } from '@mui/icons-material';
import { useMemo } from 'react';
import { getObjectGridColumns } from './objectGridUtils';
import { getIdsForGridSelectedRows } from '../../_helpers/getIdsForGridSelectedRows';

const ObjectsGrid = ({ rows }) => {
  const { t, i18n } = useTranslation()
  const apiRef = useGridApiRef();
  const app = useSelector((state) => state.app);
  const [rowData, setRowData] = useState([]);
  const keyPrefix = app === apps.huisinfo ? "BUYERS_GUIDE" : "GENERAL";
  const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
  const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
    LOCAL_STORAGE_GRID_KEYS.OBJECTS_PAGINATION[keyPrefix], undefined
  ))


  useEffect(() => {
    if (rows?.length) {
      setRowData(rows.map((row) => ({ ...row, id: row.buildingId })));
    }
  }, [rows]);

  const resolverIds = useMemo(() => {
    return getIdsForGridSelectedRows(rowSelectionModel, rowData);
  }, [rowSelectionModel, rowData]);

  const statusOptions = [
    ...new Set(rowData.map((item) => item.status))
  ];
  const columns = getObjectGridColumns({ t, keyPrefix, i18n, apiRef, statusOptions })

  const handleDeleteSelectedRows = useCallback(() => {
    setRowData((prev) => prev.filter((row) => !resolverIds.includes(row.id)));
    setRowSelectionModel(INITIAL_ROW_SELECTION_MODEL);
  }, [resolverIds]);

  const getToolbarProps = useMemo(() => {
    return {
      taskMenuListItems: resolverIds.length > 0
        ? [
          {
            title: t("general.delete"),
            icon: (props) => <Delete {...props} />,
            onClick: handleDeleteSelectedRows,


          },
        ]
        : [],
      title: t("general.objects"),
    };
  }, [rowSelectionModel, t, handleDeleteSelectedRows]);

  const onPaginationModelChange = useCallback((newPaginationModel) => {
    setPaginationModel(newPaginationModel)
    setLocalStorageItem(
      LOCAL_STORAGE_GRID_KEYS.OBJECTS_PAGINATION[keyPrefix],
      newPaginationModel
    );
  }, [keyPrefix])

  const getObjectsForPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
    const userSelectedRows = isAllSelected ? rowData : idsToExport.map(id => rowData?.find(item => item?.buildingId === id));
    return userSelectedRows;
  };

  return (
    <>
      <DataGridV2
        localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.OBJECTS_SEARCH_TEXT[keyPrefix]}
        localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.OBJECTS_COLUMN_FILTER[keyPrefix]}
        localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.OBJECTS_COLUMN_SORT[keyPrefix]}
        localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.OBJECTS_COLUMN_ORDER[keyPrefix]}
        localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.OBJECTS_COLUMN_WIDTH[keyPrefix]}
        localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.OBJECTS_COLUMN_VISIBILITY[keyPrefix]}
        apiRef={apiRef}
        checkboxSelection
        rows={rowData}
        columns={columns}
        pagination
        filterMode="client"
        {...(!!paginationModel && { paginationModel })}
        onPaginationModelChange={onPaginationModelChange}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
        }}
        toolbarProps={{
          ...getToolbarProps,
          selectedRows: rowSelectionModel,
          getData: getObjectsForPrintAndDownload
        }}
      />
    </>
  )
}
export default ObjectsGrid
